import { z } from "zod";

export const basePostSchema = z.object({
  description: z.string().min(1, "Description is required"),
  tags: z.object({
    old: z.array(z.string()),
    new: z.array(z.string()),
  }),
  privacy: z.enum(["PUBLIC", "PRIVATE", "CLOSED"]),
  achievementId: z.number().nullable(),
  selectedUsers: z.array(z.number()),
  selectedGroups: z.array(z.number()),
});

export const createPostSchema = basePostSchema.extend({
  media: z.array(z.any()).min(1, "At least one media item is required"),
});

export const sharePostSchema = basePostSchema.extend({
  media: z.array(z.any()).default([]),
});
